import InputFormatValue from "./InputFormatValue";

export default InputFormatValue;
